import { ArrowUpRight } from "lucide-react";
import { services } from "../content";
import { scrollToId } from "../lib/scroll";
import { Reveal } from "./Reveal";

export const Services = () => (
  <section id="servicos" className="scroll-mt-20 bg-[#F7F7F5] py-24 md:py-36" data-testid="services-section">
    <div className="mx-auto max-w-7xl px-6">
      <div className="grid gap-10 md:grid-cols-12 md:items-end">
        <div className="md:col-span-7">
          <Reveal>
            <span className="rounded-full bg-black px-3.5 py-1.5 font-mono text-[10px] uppercase tracking-[0.22em] text-white">
              Serviços
            </span>
          </Reveal>
          <Reveal delay={0.08}>
            <h2 className="mt-6 font-display text-4xl font-extrabold leading-[0.98] tracking-tighter text-[#1A1A1A] sm:text-5xl lg:text-6xl">
              O que eu posso
              <br />
              criar com você.
            </h2>
          </Reveal>
        </div>
        <Reveal delay={0.14} className="md:col-span-5">
          <p className="text-sm leading-relaxed text-black/60 md:text-base">
            Quatro frentes de trabalho, um mesmo objetivo: fazer a tecnologia parecer simples para quem assiste.
          </p>
        </Reveal>
      </div>

      <div className="mt-16 border-t border-black/10">
        {services.map((service, i) => (
          <Reveal key={service.number} delay={i * 0.05}>
            <button
              type="button"
              data-testid={`service-item-${service.number}`}
              onClick={() => scrollToId("contato")}
              aria-label={`${service.title} — falar sobre este serviço`}
              className="group flex w-full items-center gap-6 border-b border-black/10 py-8 text-left transition-colors duration-300 hover:bg-white md:gap-10 md:px-6 md:py-10"
            >
              <span className="font-mono text-xs tracking-[0.2em] text-black/40 transition-colors duration-300 group-hover:text-[#1D4E89]">
                {service.number}
              </span>
              <span className="flex-1 font-display text-2xl font-bold leading-tight tracking-tight text-[#1A1A1A] md:text-4xl">
                {service.title}
              </span>
              <span className="grid h-10 w-10 -translate-x-2 place-items-center rounded-full border border-black/15 text-black/50 opacity-0 transition-all duration-300 group-hover:translate-x-0 group-hover:border-[#1D4E89] group-hover:text-[#1D4E89] group-hover:opacity-100">
                <ArrowUpRight size={16} />
              </span>
            </button>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
